import React from 'react';
import ProtectedRoute from './protected';
import RochatPage from '../pages/ro-chat';

export const RochatRoutes = [
  <ProtectedRoute exact path='/ro-chat' component={RochatPage} />,
]